import { useTheme } from "@mui/material/styles";
import { useRef } from "react";

import { usePrimaryFactionFullyLoaded } from "src/client/human/singletons/CentralLoader";
import { GameUIRoot } from "src/client/human/ui/GameUIRoot";

import { useGame } from "../../GameContext";
import "./BoardView.css";
import { useBoardViewport } from "./useBoardViewport";

// This shows up when the load sequence has completed.
export function BoardViewport() {
  const theme = useTheme();
  const game = useGame();
  const canvasHost = useRef<HTMLDivElement>(null);

  useBoardViewport(canvasHost, theme.palette.background.default, game);

  return <div ref={canvasHost} className="board-view" />;
}

// Main entrypoint.
export function BoardView() {
  const loaded = usePrimaryFactionFullyLoaded();

  return (
    <>
      <GameUIRoot />
      {loaded ? <BoardViewport /> : null}
    </>
  );
}
